import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trash',
  templateUrl: './trash.component.html',
  styleUrl: './trash.component.scss'
})
export class TrashComponent implements OnInit {

  selectedIndex: number = 0;
  isSmallScreen: boolean = false;

  constructor(
    private readonly _breakpointObserver: BreakpointObserver,
  ) {
    this.selectedIndex = parseInt(sessionStorage.getItem('trashTabIndex') || '0');
  }

  ngOnInit(): void {
    this._breakpointObserver
    .observe([Breakpoints.HandsetPortrait])
    .subscribe((state: BreakpointState) => {
      this.isSmallScreen = state.matches;
    });
  }

  public changeSelectTabIndex(index: number): void {
    sessionStorage.setItem('trashTabIndex', index.toString());
  }
  
}
